var render = function (_h,_vm) {var _c=_vm._c;return _c('nav',_vm._b({staticClass:"nav level"},'nav',_vm.data.attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }